// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2TqTV","title":"AfterFrontImage_title__2pp7n"};